// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6992 ? "be74e82d" : chunkId) + "." + {"4362":"74d35f8e13cddc90","6992":"2c85d35dbda3e702"}[chunkId] + ".js";
};